// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__lwiUw","buttons":"Form_buttons__OJ5mO","radio":"Form_radio__OE7Rs","subtitle":"Form_subtitle__4J367"};